import { CheckboxGroup, Span } from "@icg360/design-system";

import { MultiStepFormLayout } from "components/multi-step-form-layout";
import { NO_POOL_STEP_COUNT } from "consts";
import { useMultiStepFormState } from "hooks/use-multi-step-form-state";

import {
  PropertyUpdatePoolContext,
  type PropertyUpdatePoolContextState,
} from ".";

export const PoolConfirmation = () => {
  const { formNavigate, state, setFields } =
    useMultiStepFormState<PropertyUpdatePoolContextState>(
      PropertyUpdatePoolContext,
    );

  return (
    <MultiStepFormLayout
      step={NO_POOL_STEP_COUNT}
      totalSteps={NO_POOL_STEP_COUNT}
      heading="Please review and confirm your updates"
      buttonProps={{
        primary: {
          disabled: !state?.confirmNoPool,
          path: "../review",
          text: "Next",
        },
        cancel: { path: "/my/property" },
        formNavigate,
      }}
    >
      <Span>
        I confirm that I no longer own or have never owned a pool on my
        property. I agree to notify SageSure in the future if I add a pool, and
        I understand liability coverage is excluded.
      </Span>

      <CheckboxGroup
        aria-label="Yes, I agree."
        value={[state?.confirmNoPool && "confirm"]}
      >
        <CheckboxGroup.Checkbox
          value="confirm"
          onChange={(val) => {
            setFields({ confirmNoPool: val });
          }}
        >
          Yes, I agree
        </CheckboxGroup.Checkbox>
      </CheckboxGroup>
    </MultiStepFormLayout>
  );
};
